import styled from "styled-components";
import { IEmployeeFile, IFile } from "../../globals/interfaces";
import { useEffect, useRef, useState } from "react";
import PDFViewer from "../PDFViewer";

export default function RenderFile({
    file,
    fileBase64
}: {
    file: IEmployeeFile;
    fileBase64: string;
}) {

    const { s_file_name = '' } = file;
    const imageFile = checkImageFile(file.s_file_name);

    if (imageFile) {
        return <Img src={fileBase64} />;
    }

    if (s_file_name.includes('pdf')) {
        return (
            <PDFViewer 
                link={file.accessLink}
            />
        );
    }

    return (
        <h6>
            No preview for this type of file (non-image), please
            download.
        </h6>
    );
}

export const checkImageFile = (name: string) => {
    const images = ['jpeg', 'jpg', 'png'];
    for (const img of images) {
        if (name.includes(img)) {
            return true;
        }
    }
    return false;
}

const Img = styled.img`
    width: 700px;
    height: auto;
`;
